export interface DeviceSize {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

const size: DeviceSize = {
  xs: '400px', // small mobile screen
  sm: '600px', // regular mobile screen
  md: '900px', // tablets
  lg: '1280px', // laptops
  xl: '1440px', // desktop
};

export const device = {
  xs: `(max-width: ${size.xs})`,
  sm: `(max-width: ${size.sm})`,
  md: `(max-width: ${size.md})`,
  lg: `(max-width: ${size.lg})`,
  xl: `(max-width: ${size.xl})`,
};
